export default __webpack_public_path__ + "static-front/media/ClockIcon.67dc3a36.svg";